import React, { useState, useEffect } from 'react';
import { Col, Row, Container, Table, Form } from 'react-bootstrap';
import NavBar from '../Components/NavBar';
import SideNavbar from '../Components/SideNavbar';
import '../index.css'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { configureWatchAction } from '../Store/Actions/participant'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { Auth } from 'aws-amplify'
import AlertBox from '../Components/AlertBox'
import axios from 'axios';
import getApiUrl from '../config';


function EditConfigureWatch(props) {
    const [currentSideActive, setCurrentSideActive] = useState(4)
    const [selectValue, setSelectValue] = useState("totalPar");
    const [order, setOrder] = useState("normal");
    const [campaignList, setCampaignList] = useState([])
    const [participantList, setParticipantList] = useState([])
    const [alertShow, setAlertShow] = useState([false, ""])
    const [errorMsg, setErrorMsg] = useState("");
    const navigate = useNavigate()
    const [tempCampaignId, setTempCampaignId] = useState("")
    const [showForm, setShowForm] = useState(false)
    const [managerList, setManagerList] = useState([])
    const [currentCampaign, setCurrentCampaign] = useState({})


    useEffect(() => {
        Auth.currentSession().then(session => {
            if (session.isValid()) {
                let role = session.getIdToken().payload["custom:role"];
                if (role == "admin") {
                    navigate("/managerDashboard")
                }
                else if (role == "participant") {
                    navigate("/participantDashboard")
                }
                else {
                    if (localStorage.getItem("managerId") == null) {
                        let id = session.getIdToken().payload["custom:id"];
                        localStorage.setItem("managerId", id)
                    }
                    getTheCampaignList()
                }
            }
            else {
                Auth.signOut()
                navigate("/")
            }
        }).catch(error => {
            Auth.signOut()
            navigate("/")
        })
    }, [])

    useEffect(() => async () => {


    }, [])

    const getTheCampaignList = async () => {
        try {
            const session = await Auth.currentSession();
            const token = session.getIdToken().getJwtToken();

            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            };
            const requestData = {
                coordinatorid: localStorage.getItem("coordinatorId")
            };

            const res = await axios.post(getApiUrl('newGetCoordinatorPermissions'), requestData, config)
            console.log(res)
            let data_response = res.data
            setManagerList(data_response)
        }
        catch (err) {
            setAlertShow([true, "danger"])
            setErrorMsg(err.message)
            console.log(err)
        }
    }


    // const getTheCampaignList = async () =>{
    //     try{
    //         const response = await axios.post(getApiUrl('newGetCampaignList'),{
    //         manager_id : localStorage.getItem("managerId"),

    //     })
    //         console.log(response)
    //         setCampaignList(JSON.parse(response.data.body).campaigns)
    //     }
    //     catch(error){
    //         console.log(error)
    //     }
    // }

    const details = {
        campaign_id: "",
        participant_id: "",
        watchid: "",
        updated_watchid: "",
        starttime: "",
        endtime: ""
    }
    const [configureDetails, setConfigureDetails] = useState(details)


    const handleChange = (e, key) => {
        if (key == "campaign_id") {
            setTempCampaignId(JSON.parse(e.target.value).campaignid)
        }

        const newObject = { ...configureDetails }
        if (key == "campaign_id") {
            newObject[key] = JSON.parse(e.target.value).campaignid
        } else {
            newObject[key] = e.target.value
        }

        setConfigureDetails(newObject)

    }

    const handleParticipantChange = async (e, campaign_id) => {
        try {
            const session = await Auth.currentSession();
            const token = session.getIdToken().getJwtToken();

            // 2. Add Authorization to Config
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            };
            const response = await axios.post(getApiUrl('newGetWatchConfig'), {
                //manager_id : localStorage.getItem("managerId"),
                campaign_id: currentCampaign["campaignid"], //localStorage.getItem("campaignId")
                participant_id: e.target.value
            }, config)
            if (response.status !== 200) {
                setAlertShow([true, "danger"])
                setErrorMsg(response.data.error)
            }
            console.log("Watch config API response:", response.data)
            const data = response.data
            const newObject = { ...configureDetails }
            // Convert datetime strings from "YYYY-MM-DD HH:MM:SS" to "YYYY-MM-DDTHH:MM" for datetime-local input
            const formatDateTime = (dateStr) => {
                if (!dateStr) return "";
                return dateStr.replace(" ", "T").substring(0, 16);
            }
            newObject["starttime"] = formatDateTime(data.starttime)
            newObject["endtime"] = formatDateTime(data.endtime)
            newObject["watchid"] = data.watchid
            newObject["updated_watchid"] = data.watchid
            newObject["participant_id"] = e.target.value
            newObject["campaign_id"] = campaign_id
            setConfigureDetails(newObject)
        }
        catch (error) {
            setAlertShow([true, "danger"])
            setErrorMsg(error.message)
            console.log(error)
        }

    }

    const handleSubmit = async () => {
        //configureDetails.manager_id = localStorage.getItem("managerId")
        //console.log(configureDetails)
        handleConfigureWatch(configureDetails)
        //await props.configureWatch(configureDetails)
        //navigate("/campaignDashboard")

    }

    const handleConfigureWatch = async (configDetails) => {
        try {
            const session = await Auth.currentSession();
            const token = session.getIdToken().getJwtToken();
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            };
            const response = await axios.post(getApiUrl('newUpdateWatchConfig'), configDetails, config)
            if (response.status !== 200) {
                setAlertShow([true, "danger"])
                setErrorMsg(response.data.error)
                window.scrollTo(0, 0)
            }
            else {
                console.log("SUCCESS: Watch configured successfully")
                setAlertShow([true, "success"])
                setErrorMsg("Watch configured successfully")
                window.scrollTo(0, 0)
                // navigate("/coordinatorDashboard")
            }
        }
        catch (err) {
            setAlertShow([true, "danger"])
            setErrorMsg(err.message)
            window.scrollTo(0, 0)
            console.log(err)
        }
    }

    useEffect(() => {
        console.log(currentCampaign)
        if (Object.keys(currentCampaign).length !== 0) {
            handleCampaignChange()
        }

    }, [currentCampaign])

    const handleCampaignChange = async () => {
        console.log("This campaign change")
        try {
            const session = await Auth.currentSession();
            const token = session.getIdToken().getJwtToken();
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            };
            const response = await axios.post(getApiUrl('newGetParticipantList'), {
                manager_id: currentCampaign["managerid"],
                campaign_id: currentCampaign["campaignid"]
            }, config)
            if (response.status !== 200) {
                setAlertShow([true, "danger"])
                setErrorMsg(response.data.error)
            }
            console.log(response)
            setParticipantList(response.data.participants)
            setShowForm(true)
        }
        catch (error) {
            setAlertShow([true, "danger"])
            setErrorMsg(error.message)
            console.log(error)
        }

    }


    return (
        <div style={{ height: "100%", overflowY: "auto" }} className="bg-image">
            <NavBar />
            <div style={{ height: "inherit" }}>
                <Container style={{ height: "100%" }}>
                    <Row style={{ height: "100%" }}>
                        <Col lg={2} style={{ height: "75%" }}>
                            <SideNavbar list={["Coordinator Dashboard", "Edit Watch Configuration"]} active={1} links={["/coordinatorDashboard", "/editConfigureWatchCoordinator"]} />
                        </Col>
                        <Col style={{ height: "75%" }}>
                            {alertShow[0] && (
                                <div style={{ marginBottom: '20px' }}>
                                    <AlertBox type={alertShow[1]} message={errorMsg} />
                                </div>
                            )}
                            <h2>Edit Configure Watch</h2>
                            <hr />
                            <Container className="p-4" style={{ background: "rgba(255,255,255,0.3)", height: "50%", overflowY: "auto" }}>


                                <Col className='mt-3'>
                                    <Form.Group>
                                        <Form.Label>Select Campaign</Form.Label>
                                        <Form.Select style={{ background: "rgba(0,0,0,0.05)" }} onChange={(e) => { handleChange(e, "campaign_id"); setCurrentCampaign(JSON.parse(e.target.value)) }}>
                                            <option value="">select option</option>
                                            {managerList.map((data, index) =>
                                                (<option key={index} value={JSON.stringify(data)}>{data.campaignid}</option>)
                                            )}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col className='mt-3'>
                                    <Form.Group>
                                        <Form.Label>Select Participant</Form.Label>
                                        <Form.Select style={{ background: "rgba(0,0,0,0.05)" }} onChange={(e) => { handleChange(e, "participant_id"); handleParticipantChange(e, configureDetails.campaign_id) }}>
                                            <option>select option</option>
                                            {participantList.map((data) => (<option key={data.participant_id} value={data.participant_id}>{data.participant_id}</option>))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Container>
                            <hr></hr>
                            {showForm && <Container className="p-4" style={{ background: "rgba(255,255,255,0.3)", height: "inherit", overflowY: "auto" }}>
                                <Form onSubmit={(e) => { e.preventDefault(); handleSubmit() }}>
                                    <Col className='mt-3'>
                                        <Form.Group>
                                            <Form.Label>Enter Watch ID</Form.Label>
                                            <Form.Control value={configureDetails.updated_watchid} type="text" style={{ background: "rgba(0,0,0,0.05)" }} onChange={(e) => { handleChange(e, "updated_watchid") }} />
                                        </Form.Group>
                                    </Col>

                                    <Col className='mt-3'>
                                        <Form.Group>
                                            <Form.Label>Start Date</Form.Label>
                                            <Form.Control value={configureDetails.starttime} type="datetime-local" style={{ background: "rgba(0,0,0,0.05)" }} onChange={(e) => { handleChange(e, "starttime") }} />
                                        </Form.Group>
                                    </Col>

                                    <Col className='mt-3'>
                                        <Form.Group>
                                            <Form.Label>End Date</Form.Label>
                                            <Form.Control value={configureDetails.endtime} type="datetime-local" style={{ background: "rgba(0,0,0,0.05)" }} onChange={(e) => { handleChange(e, "endtime") }} />
                                        </Form.Group>
                                    </Col>







                                    <Col>
                                        <Form.Control type="submit" className='btn btn-primary mt-5' value={"Configure"} />
                                    </Col>


                                </Form>
                            </Container>}

                        </Col>
                    </Row>
                </Container>
            </div>

        </div>

    );
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        manager: state.manager,
        campaign: state.campaign,
        state: state.state
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        configureWatch: (configuration) => dispatch(configureWatchAction(configuration))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(EditConfigureWatch);
